var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 3.9974H17.5L14.1667 0.664062H0.833374V27.3307H34.1667V3.9974ZM10.55 20.6641L5.83337 15.9474L8.18337 13.5974L10.5334 15.9474L16.4334 10.0474L18.7834 12.3974L10.55 20.6641ZM26.5167 15.6641L29.1667 18.3141L26.8167 20.6641L24.1667 18.0141L21.5167 20.6641L19.1667 18.3141L21.8167 15.6641L19.1667 13.0141L21.5167 10.6641L24.1667 13.3141L26.8167 10.6641L29.1667 13.0141L26.5167 15.6641Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRules);
export default __webpack_public_path__ + "static/media/messageRules.58a0d38775ae184e0ec69a2a1d2d6ad2.svg";
export { ForwardRef as ReactComponent };